import React from 'react';
import {FormattedMessage} from "react-intl";

import SidebarHeadingTitle from "../../SidebarHeadingTitle";
import DashboardItem from "./components/DashboardItem";
import OrdersItem from "./components/OrdersItem";
import QuotesItem from "./components/QuotesItem";
import PrintersItem from "./components/PrintersItem";
import RetailersItem from "./components/RetailersItem";
import QuotesStatisticsItem from "./components/QuotesStatisticsItem";
import ProductsItem from "./components/ProductsItem";

function OMSMenu(props) {
    return (
        <div style={{
            padding: '12px',
            marginTop: '20px',
            marginBottom: '20px'
        }}>
            <SidebarHeadingTitle>
                <FormattedMessage id='sidebar.menu.title' />
            </SidebarHeadingTitle>
            <DashboardItem />
            <OrdersItem />
            <RetailersItem />
            <ProductsItem />
            <QuotesStatisticsItem />
            <QuotesItem />
            <PrintersItem />
        </div>
    );
}

export default OMSMenu;
